import style from './index.module.scss';

export default function Header(onclick: () => void) {
    return (
        <div className={style.wrapper}>
            <a className={style.mainLink} href="/metaphorVis">
                MetaphorVis
            </a>
            <div className={style.iconWrapper} style={{ marginRight: '-35px' }}>
                <div className={style.tutorialBtn} onClick={onclick}>
                    <svg
                        version="1.1"
                        id="Capa_1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        viewBox="0 0 400.548 400.548"
                        xmlSpace="preserve"
                        fill="white"
                    >
                        <path
                            d="M383.86,99.79c-10.104-4.184-21.731-1.873-29.466,5.86l-51.507,51.512v-31.397c0-22.359-18.13-40.491-40.493-40.491H40.493
	C18.131,85.274,0,103.406,0,125.765v149.018c0,22.359,18.131,40.491,40.493,40.491h221.901c22.363,0,40.493-18.132,40.493-40.491
	v-31.398l51.507,51.512c5.177,5.174,12.088,7.924,19.126,7.924c3.481,0,6.995-0.678,10.34-2.063
	c10.099-4.185,16.688-14.042,16.688-24.978V124.767C400.548,113.831,393.959,103.974,383.86,99.79z M190.309,210.764l-55.191,42.403
	c-2.354,1.812-5.2,2.738-8.06,2.738c-1.991,0-3.99-0.448-5.846-1.363c-4.519-2.226-7.38-6.825-7.38-11.865v-84.807
	c0-5.041,2.861-9.639,7.38-11.864c4.521-2.228,9.911-1.696,13.905,1.375l55.191,42.402c3.26,2.504,5.17,6.381,5.17,10.49
	C195.479,204.383,193.569,208.26,190.309,210.764z"
                        />
                    </svg>
                </div>
                {/* <a className={style.githubBtn} href="https://github.com/hm00081/metaphorVis" target="_blank" rel="noreferrer">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white">
                        <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
                    </svg>
                </a> */}
            </div>
        </div>
    );
}
